<template>
  <transition name="fadeUp">
  <div class="modal" v-show="isShow">
    <div class="modal__bg" v-bind:class="{ opaque: opaque }"></div>
    <div class="modal__body" :style="{marginTop: top}">
      <div class="modal__text" v-html="text"></div>
      <div class="modal__link" v-if="link">
        <a @click="goto">{{ link.text }}</a>
      </div>
      <div class="modal__err" v-show="err" v-html="err"></div>
      <div class="modal__button">
        <div class="button" @click="clickOK">OK</div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
import { ModalEvent } from "../../modal/ModalEvent";
import * as types from "../../modal/ModalEventType";
import { setPage } from "../../util/StoreUtil";

export default {
  name: "Modal",
  data() {
    return {
      isShow: false,
      text: null,
      link: null,
      err: null,
      opaque: false,
      top: 0
    };
  },
  mounted() {
    console.log("modal mounted");
    ModalEvent.on(types.SHOW, data => {
      this.isShow = true;
      this.text = data.text;
      this.link = data.link;
      this.err = data.err;
      this.opaque = data.opaque;
      if (data.top)
        this.top = data.top;
      else
        this.top = 0;
    });
    ModalEvent.on(types.HIDE, () => {
      this.isShow = false;
    });
  },
  methods: {
    clickOK() {
      this.isShow = false;
      ModalEvent.emit(types.CLOSED);
    },
    goto() {
      this.isShow = false;
      setPage(this.link.href);
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"
.modal
    position: fixed
    z-index: $z_modal
    @include fit
    .modal__bg
        position: absolute
        @include fit
        z-index: 0
        background-color: rgba(0, 0, 0, 0.8)
        &.opaque
          background-color: black
    .modal__body
        line-height: 1.8
        position: absolute
        @include fit
        z-index: 1
        @include flexCenter()
        flex-direction: column
        flex-wrap: wrap
        text-align: center
    .modal__err
        margin-bottom: 2.0em

    .modal__text
        margin-bottom: 2.0em
        width: 90%
        p:last-child
          margin-bottom: 0
    .modal__link
        margin-top: -1.5em
        margin-bottom: 2.5em
        text-decoration: underline
</style>
<style lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"
.modal__text
  h2
    font-size: 17.5px
    margin-bottom: 1em
    @include bold
  p
    margin-bottom: 1em
    &:last-child
      margin-bottom: 0



.fadeUp-enter-active
  transition: all .3s cubic-bezier(.02,.53,.15,1)
.fadeUp-leave-active
  transition: all .0s ease-out
.fadeUp-enter, .fadeUp-leave-to
  opacity: 0
.fadeUp-enter
  transform: translateY(15px)
</style>
